import { Col, Container, Row } from "reactstrap";
import Chip from "src/components/Common/UI/Chips/Chip";
import LinesAndPhoneCentersHeader from "./PhoneCenterHeaders";
import PhoneCenters from "./PhoneCenters/PhoneCenters";



const PhoneCentersConfiguration = () =>{
  
    const chipHeaders = [""];
    const chipItems: React.ReactNode[] = [
      <PhoneCenters />,
      
    ];
  
    return (
      <div className="page-content">
        <LinesAndPhoneCentersHeader />
  
        <Container fluid>
          <Row>
            <Col xs={12}>
              {<Chip
                tabNavHeaderItems={chipHeaders}
                tabContentItems={chipItems}
                hasStatusCircle={false}
              />}
            </Col>
          </Row>
        </Container>
  
  
      </div>
    );
}

export default PhoneCentersConfiguration